import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppStreamEnvironment, ErmCapabilityApiClientService, StartStreamingSessionRequest } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-launch',
  templateUrl: './launch.component.html',
  styleUrls: ['./launch.component.scss']
})
export class LaunchComponent implements OnInit {

  env?: AppStreamEnvironment;
  isWorking = false;
  isInitializing = false;
  isLaunching = false;
  isErmUnavailable = false;

  constructor(
    private route: ActivatedRoute,
    private ermCapabilityApiClient: ErmCapabilityApiClientService
  ) { }

  async ngOnInit(): Promise<void> {

    try {
      this.isWorking = true;

      // Get route parameters
      const params = this.route.snapshot.params;
      const launchEnvId = params['envId'];

      // Get route data
      const data = this.route.snapshot.data;
      const clientType = data['clientType'];
      const fleetKind = data['fleetKind'];

      // Get environment
      const getAppStreamEnvironmentResponse = await this.ermCapabilityApiClient.getAppStreamEnvironment(launchEnvId);
      this.env = getAppStreamEnvironmentResponse.body?.appStreamEnvironment;

      // Get user settings
      const getUserSettingsResponse = await this.ermCapabilityApiClient.getUserSettings();
      const userSettings = getUserSettingsResponse.body?.userSettings;

      // Launch streaming session
      this.isInitializing = true;

      // The culture name is derived from its corresponding BCP-47 language tag
      const cultureName = navigator.language;
      const environmentId = this.env?.environmentId;
      const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const startRequest = new StartStreamingSessionRequest({
        cultureName: cultureName,
        environmentId: environmentId,
        fleetKind: fleetKind,
        timeZoneId: timeZoneId,
        onErrorRedirect: `#/erm/launch/${environmentId}/error/{errorCode}`
      });

      // If user has opted in for native client
      if ((clientType === 'auto' && userSettings?.isNativeClientEnabled === true) || clientType === 'native') {
        startRequest.onReadyRedirect = `#/erm/launch/${fleetKind}/${environmentId}/native/{streamingUrl}`;
      }

      // Request start of streaming session
      const response = await this.ermCapabilityApiClient.startAppStreamSession(startRequest);
      if (!response.ok) {
        throw Error('Error during start of AppStream streaming session.');
      }
      const authorizeUrl = response.body?.authorizeUrl;
      if (!authorizeUrl) {
        throw Error('Could not obtain autorize url.');
      }
      this.isInitializing = false;
      this.isLaunching = true;

      // Redirect to authorize url
      window.location.href = authorizeUrl;
    } catch (error) {
      this.isErmUnavailable = true;
      this.isWorking = false;
      this.isInitializing = false;
      this.isLaunching = false;
      throw error;
    }
  }
}
